import React, { useEffect, useState } from "react";
import { useLocation } from "nystem-components";
import app from "nystem";
const OverlayIndex = ({ children }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState({});
  const [atPathname, setAtPathname] = useState("");

  useEffect(() => {
    const overlayEvent = options => {
      let newOpen = open;
      if (options.do === "open") newOpen[options.overlayId] = true;
      else if (options.do === "close") {
        if (options.overlayId) delete newOpen[options.overlayId];
        else newOpen = {};
      }
      setOpen({ ...newOpen });
    };

    app.on("overlay", overlayEvent);
    if (atPathname !== pathname) {
      app.event("overlay", { do: "close" });
      setAtPathname(pathname);
    }

    return () => {
      app.off("overlay", overlayEvent);
    };
  }, [pathname, open]);

  const items =
    children instanceof Array ? children : children ? [children] : [];
  return items.map(child =>
    open[child.key] ? (
      <React.Fragment
        key={child.key}
      >
        {child}
      </React.Fragment>
    ) : null
  );
};
export default OverlayIndex;
